/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class DeadlineSelector extends PureComponent {
  constructor(props) {
    super(props);

    this.deadlineOptions = [
      { text: 'None', value: -1 },
      { text: '1 hour', value: 1 },
      { text: '3 hours', value: 3 },
      { text: '12 hours', value: 12 },
      { text: '1 day', value: 24 },
      { text: '3 days', value: 72 },
      { text: '7 days', value: 168 },
      { text: '14 days', value: 336 },
      { text: '30 days', value: 720 }
    ];
  }

  handleDeadlineChange = (ev) => {
    const {
      target: {
        value
      }
    } = ev;

    const {
      onChange
    } = this.props;

    onChange(value);
  };

  render() {
    const deadlineOptionElements = this.deadlineOptions.map(option => (
      <option
        key={option.value}
        value={option.value}
      >
        {option.text}
      </option>
    ));

    const {
      deadline
    } = this.props;

    return (
      <select
        className="form-control"
        onChange={this.handleDeadlineChange}
        value={deadline}
      >
        {deadlineOptionElements}
      </select>
    );
  }
}

/*------------------------------------------------*/
/* PROP TYPES
/*------------------------------------------------*/
DeadlineSelector.defaultProps = {
  deadline: -1
};

DeadlineSelector.propTypes = {
  // Optional props
  deadline: PropTypes.number,

  // Required methods
  onChange: PropTypes.func.isRequired
};

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default DeadlineSelector;
